import React, {useEffect, useState} from 'react';
import {useTheme} from "../../common/ProjectThemeProvider";
import {
    binaryToBool,
    boolToBinary,
    checkNullJson,
    checkNullStr,
    createTimeout,
    deepObjectComparison,
    focusFormIdElement,
    getCurrUrlParamValue,
    getDefStr,
    getFutureDate,
    getJsonValue,
    isAlphanumeric,
    isBoolTrue,
    isJsonValueTrue,
    parseInteger,
    trim
} from "../../common/fusion-ui/utils/ReactUtils";
import {sendAdminRequest} from "../utils/AdminUtils";
import {printError, printLog,} from "../../common/CommonUtils";
import {useToast} from "../../common/fusion-ui/provider/ToastProvider";
import {useNavigate} from "react-router-dom";
import {AdminModuleFieldsData, AdminModuleRouteUrls, AdminModules, AdminReqUrls, ShowViewType} from "../config/AdminConfig";
import {Flexbox, GridBox, IMsgButton, Label, RadioToggle} from "../../common/fusion-ui";
import {CssVariant, DurationUnits, Messages, Patterns} from "../../common/fusion-ui/config/FusionConfig";
import {ThemedInput} from "../../common/components";
import {FormPageRoot} from "../components";
import {ThemedDropdownMenu} from "../../app";
import {formatDateValue} from "../../app/utils/AppUtils";
import {Keys} from "../../app/config/AppConfig";
import {FramerAnimator} from "../../common/fusion-ui/animation/FramerAnimator";
import {useInternetStatus} from "../../common/fusion-ui/hook";
import {UnderMaintenance, UnderMaintenanceMsg} from "../../common/CommonConfig";

const LoginBypassManager__EditFormPage = React.memo(({
                                                         updateOnly,
                                                         open,
                                                         onHide,
                                                         recordId,
                                                         showAs = ShowViewType.PAGE,
                                                         onSuccess,
                                                     }) => {
    const TAG = "LoginBypassManager__EditFormPage";

    const moduleName = AdminModules.LoginBypassManager;
    const mf = AdminModuleFieldsData[moduleName];

    const theme = useTheme();
    const navigate = useNavigate();
    const {showToast, changeToastVariant} = useToast();
    const {isOnline, internetCheckingMsg} = useInternetStatus();
    const animator = new FramerAnimator();

    const FOCUS_DELAY = 2000;
    const Fields = {
        updateRecordId: 'updateRecordId',

        isUpdateFormDataFetched: 'isUpdateFormDataFetched',

        isDataLoading: 'isDataLoading',
        isDataFound: 'isDataFound',
        dataLoadingMsg: 'dataLoadingMsg',

        submitBtn_AsLoading: 'submitBtn_AsLoading',
        submitBtn_disabled: 'submitBtn_disabled',

        linkExpireInputValue: 'linkExpireInputValue',
        linkExpireDropdownItem: 'linkExpireDropdownItem',
        linkExpireDropdownOption: 'linkExpireDropdownOption',
        linkExpireDropdownOptionRepr: 'linkExpireDropdownOptionRepr',

        panelMsg: 'panelMsg',
        panelMsgColor: 'panelMsgColor',

    };
    const [fieldsData, setFieldsData] = useState({});
    // const [formData, setFormData] = useState(LoginBypassManager__EditFormPage_FormData);
    const [formData, setFormData] = useState({});
    const [formFieldsMsgs, setFormFieldsMsgs] = useState({});

    useEffect(() => {
        if (!checkNullStr(getField(Fields.panelMsg)) && !isUpdateMode()) {
            updateField(Fields.isDataLoading, false);
            updateField(Fields.isDataFound, true);
            updateField(Fields.linkExpireDropdownItem, {
                id: DurationUnits.dy.unit, name: DurationUnits.dy.unit, repr: DurationUnits.dy.repr, max: DurationUnits.dy.max
            });
            updateField(Fields.linkExpireDropdownOption, DurationUnits.dy.unit);
            updateField(Fields.linkExpireDropdownOptionRepr, DurationUnits.dy.repr);
        }

        log('useEffect.showAs:', showAs, 'recordId:', recordId, 'updateOnly:', isUpdateMode());
        if (showAs == ShowViewType.PAGE) {
            if (isUpdateMode()) {
                const id = getCurrUrlParamValue('id');
                log('useEffect.showAs:', showAs, 'id:', id);
                fetchEditModeData(id);
            }
        } else {
            if (checkNullStr(recordId) && (isUpdateMode())) {
                fetchEditModeData(recordId, false);
            }
        }
    }, [recordId, showAs, updateOnly]);

    return (<>
        <FormPageRoot
            tag={TAG}
            moduleName={moduleName}
            updateOnly={isUpdateMode()}
            isDataLoading={getField(Fields.isDataLoading)}
            isDataFound={getField(Fields.isDataFound)}
            dataLoadingMsg={getField(Fields.dataLoadingMsg)}
            // addPageTitle={'Add Bypass Link'}
            editPageTitle={'Edit Bypass Link'}
            open={open}
            onHide={() => {
                if (onHide) onHide();
                clearPanelData(true);
            }}
            showAs={showAs}
            md={showAs == ShowViewType.PAGE ? 12 : 8}
            panelMsg={getField(Fields.panelMsg)}
            panelMsgColor={getField(Fields.panelMsgColor)}
            isSubmitDisabled={isFieldTrue(Fields.submitBtn_disabled)}
            isSubmitLoading={isFieldTrue(Fields.submitBtn_AsLoading)}
            onSubmit={handleSubmit}
            onPageRefresh={() => fetchEditModeData(getField(Fields.updateRecordId), false)}
        >
            <div>
                <GridBox className={'px-2'} md={showAs == ShowViewType.PAGE ? 4 : 6} gapY={0}>

                    {/*memberName*/}
                    <ThemedInput
                        label={mf.memberName.title}
                        value={getFormField(mf.memberName)}
                        readOnly={true}
                    />

                    {/*companyName*/}
                    <ThemedInput
                        label={mf.companyName.title}
                        value={getFormField(mf.companyName)}
                        readOnly={true}
                    />

                    {/*forAnyone*/}
                    {/*<ThemedInput*/}
                    {/*    label={mf.forAnyone.title}*/}
                    {/*    // value={boolToYN(isBoolTrue(getFormField(mf.forAnyone)))}*/}
                    {/*    value={boolToYN(isBoolTrue(getFormField(mf.forAnyone), true, true))}*/}
                    {/*    readOnly={true}*/}
                    {/*/>*/}

                    {/*tokenAlias*/}
                    <ThemedInput
                        className={'mt-n1'}
                        label={mf.tokenAlias.title}
                        placeholder={mf.tokenAlias.title}
                        id={mf.tokenAlias.column}
                        value={getFormField(mf.tokenAlias)}
                        msg={getFormFieldMsg(mf.tokenAlias)}
                        required={true}
                        iMsg={`Postfix for the shared link (i.e. 'https://vok-doman.com?${Keys.urlParam_loginBypassTokenAlias}=mx2ru')`}
                        type={'text'}
                        showMsg={true}
                        onChange={(e) => {
                            const value = trim(e.target.value + '').toLowerCase();
                            if (value.length > 8) {
                                updateFormFieldMsg(mf.tokenAlias, 'Maximum length is 8 characters');
                                createTimeout(() => {
                                    updateFormFieldMsg(mf.tokenAlias, '');
                                }, 4000);
                                return false;
                            } else if (value.length < 4) {
                                updateFormFieldMsg(mf.tokenAlias, 'Minimum length is 5 characters');
                            } else {
                                if (checkNullStr(value)) {
                                    updateFormFieldMsg(mf.tokenAlias, '');
                                }
                            }
                            updateFormField(mf.tokenAlias, value);
                            panelLog('');
                        }}
                    />

                    {/*redirectUrl*/}
                    <ThemedInput
                        className={''}
                        label={mf.redirectUrl.title}
                        placeholder={mf.redirectUrl.title}
                        id={mf.redirectUrl.column}
                        value={getFormField(mf.redirectUrl)}
                        msg={getFormFieldMsg(mf.redirectUrl)}
                        required={true}
                        showMsg={true}
                        type={'text'}
                        onChange={(e) => {
                            const value = e.target.value + '';
                            updateFormField(mf.redirectUrl, value);
                            panelLog('');
                            if (checkNullStr(value)) updateFormFieldMsg(mf.redirectUrl, '');
                        }}
                    />


                    {/*shareLimit*/}
                    <ThemedInput
                        className={'mt-n1'}
                        label={mf.shareLimit.title}
                        placeholder={mf.shareLimit.title}
                        id={mf.shareLimit.column}
                        iMsg={isBoolTrue(getFormField(mf.forAnyone), true, true) ? `By default, guest-user's login-bypass-link has no limit. Min: 0, max: 1000` : 'Min: 0, max: 1000'}
                        value={getFormField(mf.shareLimit)}
                        msg={getFormFieldMsg(mf.shareLimit)}
                        required={true}
                        showMsg={true}
                        type={'number'}
                        onChange={(e) => {
                            const value = parseInteger(e.target.value);
                            if ((isBoolTrue(getFormField(mf.forAnyone), true, true) ? value >= -1 : value >= 0) && value <= 1000) {
                                updateFormField(mf.shareLimit, value);
                                panelLog('');
                                if (checkNullStr(value)) updateFormFieldMsg(mf.shareLimit, '');
                            }
                        }}
                    />

                    {/*expireAt*/}
                    {/*<ThemedInput*/}
                    {/*    label={mf.expireAt.title}*/}
                    {/*    value={getFormField(mf.expireAt)}*/}
                    {/*    readOnly={true}*/}
                    {/*/>*/}
                    {/*<ThemedInput*/}
                    {/*    label={mf.expireAtJwt.title}*/}
                    {/*    value={getFormField(mf.expireAtJwt)}*/}
                    {/*    readOnly={true}*/}
                    {/*/>*/}

                    {/*expire input & dropdown*/}
                    <div className={'mt-n1x'} style={{marginTop: '-.2rem'}}>
                        <Label className={'text-input-label px-1 m-0 p-0 mb-1x'}
                               textAt={'start'}
                               color={theme.text40} required={true}>
                            <span>Expire duration</span>
                            <span className={'ms-2 me-1'}>
                                <IMsgButton
                                    tooltip={`The link expires after the specified duration. (Default is ${isBoolTrue(getFormField(mf.forAnyone), true, true) ? `1 year` : `24 hours`}).`}/>
                            </span>
                        </Label>

                        <Flexbox className={'m-0 p-0 w-100'} position={'relative'} overflow={'hidden'}
                                 justifyAt={'start'} alignAt={'center'} borderVariant={1} roundedVariant={''}
                                 style={{borderColor: theme.text20, width: 'auto', borderRadius: '.4rem'}}>
                            {/*expire-input*/}
                            <ThemedInput
                                mainWrapperClassName={'w-100'}
                                wrapperClassName={'m-0 p-0 w-100'}
                                className={`border-none me-3 ${checkNullStr(getField(Fields.linkExpireInputValue)) ? 'pe-5' : ''}`}
                                id={mf.expireAt.column}
                                showMsg={false}
                                type={'text'}
                                showLabel={false}
                                style={{height: '32px'}}
                                placeholder={`Expire duration`}
                                pattern={Patterns.plainNumber}
                                validate={true}
                                value={getField(Fields.linkExpireInputValue)}
                                onChange={(e) => {
                                    let value = Number(e.target.value);
                                    handleExpireDateChange(getField(Fields.linkExpireDropdownItem), value, true);
                                    if (checkNullStr(value)) updateFormFieldMsg(mf.expireAt, '');
                                }}/>

                            {/*expire-dropdown*/}
                            <ThemedDropdownMenu
                                className={'ms-n2x'}
                                buttonClassName={'border-none fw-semi-bold'}
                                roundedVariant={0}
                                outlined={false}
                                buttonHeight={'32px'}
                                defOption={getField(Fields.linkExpireDropdownOption)}
                                dropdownStyle={theme.autoCompleteDropdownStyles}
                                onItemClick={(name, index, item) => {
                                    handleExpireDateChange(item);
                                }}>
                                {Object.values(DurationUnits).map(item => {
                                    return {
                                        id: item.unit, name: item.unit, repr: item.repr, max: item.max,
                                    }
                                })}
                            </ThemedDropdownMenu>
                        </Flexbox>

                        {/*expire-date label*/}
                        {(checkNullStr(getField(Fields.linkExpireInputValue)) || checkNullStr(getFormFieldMsg(mf.expireAt))) &&
                            <Label className={'fs-sm m-0 p-0 fw-semi-bold text-nowrap'}
                                   color={checkNullStr(getFormFieldMsg(mf.expireAt)) ? 'red' : theme.text70} textAt={'start'}>
                                {checkNullStr(getFormFieldMsg(mf.expireAt)) ? <span>{getFormFieldMsg(mf.expireAt)}</span> : <span>
                                        <span className={'fw-normal'}>Link will expire at: </span>
                                            <span>
                                                {formatDateValue(getFutureDate({
                                                    value: getField(Fields.linkExpireInputValue), unit: getField(Fields.linkExpireDropdownOption), format: '',
                                                }))}
                                            </span>
                                        </span>}
                            </Label>}
                    </div>

                    {/*forAnyone*/}
                    {isUpdateMode() && <RadioToggle
                        radioClassName={'w-auto'}
                        labelColor={theme.text40}
                        binary={true}
                        checked={boolToBinary(isBoolTrue(getFormField(mf.forAnyone), true, true))}
                        config={{
                            label: mf.forAnyone.titleAlt,
                            active: "YES",
                            inactive: "NO"
                        }}
                        onChange={(e, value) => {
                            log('forAnyone.onChange.value:', value);
                            updateFormField(mf.forAnyone, value);

                            if (!binaryToBool(value)) {
                                const shareLimit = parseInteger(getFormField(mf.shareLimit));
                                updateFormField(mf.shareLimit, shareLimit < 0 ? 1 : shareLimit);
                            }
                        }}
                    />}

                    {/*isActive*/}
                    <RadioToggle
                        radioClassName={'w-auto'}
                        labelColor={theme.text40}
                        binary={true}
                        required={true}
                        checked={boolToBinary(isFormFieldTrue(mf.status))}
                        config={{
                            label: mf.status.titleAlt, active: "YES", inactive: "NO"
                        }}
                        onChange={(e, value) => {
                            log('status.onChange.value:', value);
                            updateFormField(mf.status, value);
                        }}
                    />
                </GridBox>
            </div>
        </FormPageRoot>
    </>)

    function handleExpireDateChange(currDropdownItem = getField(Fields.linkExpireDropdownItem), linkExpireInputValue = getField(Fields.linkExpireInputValue), fromInput = false) {
        const fun = 'handleExpireDateChange:';
        try {
            log(fun, 'currDropdownItem:', currDropdownItem, 'linkExpireInputValue:', linkExpireInputValue);

            const unit = getJsonValue(currDropdownItem, 'name');
            const repr = getJsonValue(currDropdownItem, 'repr');
            const maxLimit = getJsonValue(currDropdownItem, 'max');

            updateField(Fields.linkExpireDropdownItem, currDropdownItem);
            updateField(Fields.linkExpireDropdownOption, unit);
            updateField(Fields.linkExpireDropdownOptionRepr, repr);

            const inputValueOrg = parseInteger(linkExpireInputValue);
            if (checkNullStr(linkExpireInputValue) && inputValueOrg > 0) {
                const inputValue = (inputValueOrg > maxLimit && !isBoolTrue(fromInput)) ? maxLimit : inputValueOrg;

                const expireAt = getFutureDate({
                    value: inputValue, unit: unit, format: '',
                })
                log(fun, 'inputValue:', inputValue, 'inputValueOrg:', inputValueOrg, 'repr:', repr, 'maxLimit:', maxLimit);

                //Update expire-value if it exceeds the max-value
                if (inputValueOrg > maxLimit) {
                    toast(`Max '${unit}' limit: ${maxLimit}`, CssVariant.warning);
                    if (!isBoolTrue(fromInput)) {
                        updateField(Fields.linkExpireInputValue, maxLimit);
                        updateFormField(mf.expireAt, expireAt);
                        updateFormField(mf.expireAtJwt, `${inputValue}${repr}`);
                    }
                } else {
                    updateField(Fields.linkExpireInputValue, inputValue);
                    updateFormField(mf.expireAt, expireAt);
                    updateFormField(mf.expireAtJwt, `${inputValue}${repr}`);
                }
            } else {
                updateField(Fields.linkExpireInputValue, '');
                updateFormField(mf.expireAt, '');
                updateFormField(mf.expireAtJwt, '');
            }
        } catch (error) {
            toast('Selection failed, please try again!');
            logErr(fun, error);
        }
    }

    function handleSubmit() {
        const fun = 'handleSubmit:';
        log(fun, 'formData:', formData);
        if (UnderMaintenance) {
            toast(UnderMaintenanceMsg, CssVariant.warning);
            return false;
        }
        if (!isOnline) {
            toast(internetCheckingMsg, CssVariant.warning);
            return false;
        }

        try {
            let allFieldsChecked = checkRequiredFields();
            // allFieldsChecked = false;//for checking
            if (allFieldsChecked) {
                updateField(Fields.submitBtn_AsLoading, true);
                updateField(Fields.submitBtn_disabled, true);
                panelLog(null);

                const REQUEST_OPTIONS = {
                    updateOnly: isUpdateMode(),
                    recordId: getField(Fields.updateRecordId),
                    formData: formData,
                };
                sendAdminRequest({
                    reqUrl: AdminReqUrls.admin__loginBypassMngr__editPage__submitRecord,
                    reqOptions: REQUEST_OPTIONS,
                    onFetched: ((fetchedData) => {
                        log(fun, 'fetchedData:', fetchedData);

                        const message = getJsonValue(fetchedData, 'message');
                        const success = isJsonValueTrue(fetchedData, 'success');

                        updateField(Fields.submitBtn_disabled, false);//for testing only
                        if (success) {
                            toast(message, CssVariant.success);
                            if (showAs == ShowViewType.PAGE) {
                                // redirectPage();
                            } else {
                                createTimeout(() => {
                                    // clearPanelData(true);
                                }, 300);
                            }
                            if (onSuccess) onSuccess();
                        } else {
                            toast(message, CssVariant.danger);
                            updateField(Fields.submitBtn_disabled, false);
                        }
                        updateField(Fields.submitBtn_AsLoading, false);
                    }),
                    onError: ((error) => {
                        toast(Messages.saveError, CssVariant.danger);
                        updateField(Fields.submitBtn_AsLoading, false);
                        updateField(Fields.submitBtn_disabled, false);
                        logErr(fun, error);
                    }),
                });
            }
        } catch (error) {
            toast(Messages.saveError, CssVariant.danger);
            updateField(Fields.submitBtn_AsLoading, false);
            updateField(Fields.submitBtn_disabled, false);
            logErr(fun, error);
        }
    }

    async function fetchEditModeData(recordId, checkBefore = true) {
        const fun = 'fetchEditModeData:';
        try {
            // log(fun, 'recordId:', recordId, 'isUpdateFormDataFetched:', isFieldTrue(Fields.isUpdateFormDataFetched));
            if (!checkBefore || (checkBefore && !isFieldTrue(Fields.isUpdateFormDataFetched))) {
                updateField(Fields.isUpdateFormDataFetched, true);
                updateField(Fields.updateRecordId, recordId);
                if (checkNullStr(recordId)) {
                    updateField(Fields.isDataLoading, true);
                    updateField(Fields.dataLoadingMsg, "");
                    setFormData({});
                    setFormFieldsMsgs({});

                    //send-request
                    const REQUEST_OPTIONS = {
                        recordId: recordId,
                    };
                    sendAdminRequest({
                        reqUrl: AdminReqUrls.admin__loginBypassMngr__edit__fetchEditRecord, reqOptions: REQUEST_OPTIONS, onFetched: (async (fetchedData) => {
                            log(fun, 'fetchedData:', fetchedData);

                            let fetchedFormData = getJsonValue(fetchedData, 'data', {});
                            const message = getJsonValue(fetchedData, 'message');
                            const success = isJsonValueTrue(fetchedData, 'success');

                            updateField(Fields.isDataFound, success);
                            if (success) {
                                //    fetchedFormData: { "expire_at": "2024-10-11T07:17:58.738Z",
                                //     "expire_at_jwt": "5w",}
                                const expireAt = getJsonValue(fetchedFormData, mf.expireAt.column);
                                const expireAtJwt = getJsonValue(fetchedFormData, mf.expireAtJwt.column);
                                const expireObj = extractNumberAndDuration(expireAtJwt);
                                const expireInputValue = expireObj.number;
                                const expireDurRepr = getDefStr(expireObj.duration, DurationUnits.dy.repr);
                                const expireDurUnitItem = Object.values(DurationUnits).find(item => item.repr == expireDurRepr);
                                const expireDurUnit = getJsonValue(expireDurUnitItem, 'unit', DurationUnits.dy.unit);

                                log(fun, 'fetchedData.expireAt:', expireAt, 'expireAtJwt:', expireAtJwt, 'expireObj:', expireObj, 'expireInputValue:', expireInputValue, 'expireDurRepr:', expireDurRepr, 'expireDurUnit:', expireDurUnit);
                                // updateField(Fields.linkExpireDropdownItem, {
                                //     id: DurationUnits.dy.unit,
                                //     name: DurationUnits.dy.unit,
                                //     repr: DurationUnits.dy.repr,
                                //     max: DurationUnits.dy.max
                                // });
                                // updateField(Fields.linkExpireDropdownOption, DurationUnits.dy.unit);
                                // updateField(Fields.linkExpireDropdownOptionRepr, DurationUnits.dy.repr);
                                updateField(Fields.linkExpireInputValue, expireInputValue);
                                updateField(Fields.linkExpireDropdownOptionRepr, expireDurRepr);
                                updateField(Fields.linkExpireDropdownOption, expireDurUnit);
                                updateField(Fields.linkExpireDropdownItem, {
                                    id: DurationUnits.dy.unit, name: DurationUnits.dy.unit, repr: DurationUnits.dy.repr, max: DurationUnits.dy.max
                                });

                                fetchedFormData = {
                                    ...fetchedFormData, // [mf.expireAt.column]:
                                };
                                setFormData(fetchedFormData);
                            } else {
                                toast(message, CssVariant.danger);
                                updateField(Fields.dataLoadingMsg, "Invalid record id!");
                            }
                            updateField(Fields.isDataLoading, false);
                        }), onError: ((error) => {
                            logErr(fun, error);
                            updateField(Fields.dataLoadingMsg, Messages.fetchError);
                            updateField(Fields.isDataFound, false);
                            updateField(Fields.isDataLoading, false);
                        }),
                    });
                } else {
                    updateField(Fields.dataLoadingMsg, 'Record-id not found!');
                    updateField(Fields.isDataFound, false);
                    updateField(Fields.isDataLoading, false);
                }
            }
        } catch (error) {
            logErr(fun, error);
            updateField(Fields.dataLoadingMsg, Messages.fetchError);
            updateField(Fields.isDataFound, false);
            updateField(Fields.isDataLoading, false);
        }
    }

    function redirectPage() {
        createTimeout(() => {
            panelLog(`Redirecting you to the '${moduleName}' page now...`);
            createTimeout(() => {
                // window.location.href = AdminModuleRouteUrls[moduleName];
                navigate(AdminModuleRouteUrls[moduleName]);
            }, 2500);
        }, 500);
    }

    function checkRequiredFields() {
        const fun = 'checkRequiredFields:';
        //mf: recordId, memberId, memberName, companyId, companyName, tokenAlias, redirectUrl, forAnyone, shareLimit, usedCount, expireAt, status, token
        const requiredFields = [mf.tokenAlias, mf.redirectUrl, mf.shareLimit, mf.expireAtJwt];

        let verified = false;
        let showMsg = true;
        let colField = {};
        for (const field of requiredFields) {
            const fieldValue = formData[field.column];
            const valLen = (fieldValue + '').trim().length;
            if (deepObjectComparison(field, mf.tokenAlias)) {
                // log(fun, 'for.tokenAlias.field:', field, 'fieldValue:', fieldValue, 'valLen:', valLen);
                if (checkNullStr(fieldValue)) {
                    showMsg = false;
                    if (typeof parseInt(fieldValue) == 'number' && !isNaN(fieldValue)) {
                        colField = field;
                        const msg = 'Token-alias can only be either alphabetical or alphanumeric!';
                        updateFormFieldMsg(colField, msg);
                        toast(`${field.title}: ${msg}!`, CssVariant.danger);
                        break;
                    } else if (isAlphanumeric(fieldValue)) {
                        if (valLen < 4) {
                            colField = field;
                            const msg = 'Minimum length for token-alias: 4';
                            updateFormFieldMsg(colField, msg);
                            toast(`${field.title}: ${msg}!`, CssVariant.danger);
                            break;
                        } else if (valLen > 8) {
                            colField = field;
                            const msg = 'Minimum length for token-alias: 4';
                            updateFormFieldMsg(colField, msg);
                            toast(`${field.title}: ${msg}!`, CssVariant.danger);
                            break;
                        } else {
                            verified = true;
                        }
                    } else {
                        colField = field;
                        const msg = 'Unknown token-alias!';
                        updateFormFieldMsg(colField, msg);
                        toast(`${field.title}: ${msg}!`, CssVariant.danger);
                        break;
                    }
                } else {
                    colField = field;
                    verified = false;
                    break;
                }
            } else if (deepObjectComparison(field, mf.expireAtJwt) && !checkNullStr(getFormField(mf.expireAtJwt))) {
                log(fun, 'for.expireAt.field:', field, 'fieldValue:', fieldValue);
                colField = field;
                showMsg = false;
                updateFormFieldMsg(colField, 'Required field');
                toast(`'${mf.expireAt.title}' cannot be empty!`, CssVariant.danger);
            } else if (!checkNullStr(fieldValue)) {
                colField = field;
                verified = false;
                break;
            } else {
                verified = true;
            }
        }
        if (!verified && checkNullJson(colField)) {
            const colTitle = getDefStr(colField.titleAlt, colField.title);
            log(fun, "!verified.colField:", colField, 'idToFocus:', colField.column);
            if (showMsg) {
                updateFormFieldMsg(colField, 'Required field');
                toast(`'${colTitle}' cannot be empty!`, CssVariant.danger);
            }
            focusIdField(colField.column);
        }
        return verified;
    }


    function focusIdField(id, onlyFocus = false) {
        focusFormIdElement(id, onlyFocus, FOCUS_DELAY);
    }

    /**
     * Extract Number & duration from a String.
     *
     * @example
     * // Example usage
     * const inputs = ['1m', '1M', '1y', '3d', '100y', '12m', '52w', '20h'];
     * inputs.forEach(input => {
     *     const result = extractNumberAndDuration(input);
     *     console.log(result);
     * });
     * //Output
     * { number: 1, duration: 'm' }
     * { number: 1, duration: 'M' }
     * { number: 1, duration: 'y' }
     * { number: 3, duration: 'd' }
     * { number: 100, duration: 'y' }
     * { number: 12, duration: 'm' }
     * { number: 52, duration: 'w' }
     * { number: 20, duration: 'h' }
     */
    function extractNumberAndDuration(input) {
        // Regular expression to match the number and duration
        const regex = /^(\d+)([a-zA-Z]+)$/;

        // Test the input string against the regex
        const match = (input + '').match(regex);

        if (match) {
            // match[1] is the number part, match[2] is the duration part
            const number = parseInt(match[1], 10);
            const duration = match[2];
            return {number, duration};
        } else {
            // If the input doesn't match the pattern, return null
            return null;
        }
    }

    function clearPanelData(refetchAddFormData = false) {
        setFormFieldsMsgs({});
        setFormData({});
        setFieldsData({});
        if (isBoolTrue(refetchAddFormData) && showAs != ShowViewType.PAGE && !isUpdateMode()) {
            updateField(Fields.dataLoadingMsg, '');
            updateField(Fields.isDataFound, true);
            updateField(Fields.isDataLoading, false);
        }
    }

    function updateField(field, value) {
        setFieldsData(prevState => ({...prevState, [field]: value}));
    }

    function getField(field, defValue) {
        return getJsonValue(fieldsData, field, defValue);
    }

    function isFieldTrue(field) {
        return isBoolTrue(getField(field), true, true);
    }

    function updateFormField(clmField, value, direct = false) {
        setFormData(prevState => ({...prevState, [direct ? clmField : clmField.column]: value}));
    }

    function getFormField(clmField, defValue, direct = false) {
        return getJsonValue(formData, direct ? clmField : clmField.column, defValue);
    }

    function isFormFieldTrue(clmField, direct = false) {
        return isBoolTrue(getFormField(clmField, null, direct), true, true);
    }

    function updateFormFieldMsg(clmField, value, direct = false) {
        setFormFieldsMsgs(prevState => ({...prevState, [direct ? clmField : clmField.column]: value}));
    }

    function getFormFieldMsg(clmField, defValue, direct = false) {
        return getJsonValue(formFieldsMsgs, direct ? clmField : clmField.column, defValue);
    }

    function isUpdateMode() {
        return isBoolTrue(updateOnly);
    }

    function toast(text, variant) {
        showToast(text);
        changeToastVariant(variant);
        log(...[text]);
    }

    function panelLog(text) {
        updateField(Fields.panelMsg, text);
        updateField(Fields.panelMsgColor, theme.text90);
        if (text) log(...[text]);
        ;
    }

    function panelLogErr(...text) {
        updateField(Fields.panelMsg, text);
        updateField(Fields.panelMsgColor, 'red');
        if (text) log(...[text]);
        ;
    }

    function log(...text) {
        printLog(TAG, ...text);
    }

    function logErr(...text) {
        printError(TAG, ...text);
    }

//======================Util Functions end=====================
});
export default LoginBypassManager__EditFormPage;
